import { useState, useEffect, memo, useRef } from 'react';

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';

import { Box, Flex, useToast } from '@chakra-ui/react';

import { CreateRoomWithAiForm } from './CreateRoomWithAiForm.jsx';
import { uploadFileMultithreaded, uploadFiles, uploadFilesReset } from '../../../digital-sales-room/actions/dsr-actions';
import { createGenAiRoom, resetCreateGenAiRoom, setNotifyGenAiRoomReady } from '../../../digital-sales-room/actions/dsr-gen-ai-actions.js';
import { redirectToNewPage, triggerLaunchdeckToast } from '../../../global/helpers/global-helpers.js';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal.jsx';
import { MdOutlineGeneratingTokens } from 'react-icons/md';


function CreateRoomWithAiModal({
  handleCloseModal,
  // Actions
  setNotifyGenAiRoomReady,
  uploadFiles,
  uploadFileMultithreaded,
  uploadFilesReset,
  createGenAiRoom,
  resetCreateGenAiRoom,
  // Redux states
  isMobileView,
  uploadFilesState,
  createGenAiRoomOutcome
}) {

  // UX
  const toast = useToast();
  const redirectRef = useRef(false)
  const [showLoader, setShowLoader] = useState(false);


  useEffect(() => {
    if (createGenAiRoomOutcome) {
      const { createdRoomRoute, genAiError } = createGenAiRoomOutcome || {};

      if (!!genAiError) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Something went wrong with generating your Room. We are aware of this problem. Please try again later",
            isMobileView
          })
        )
      }

      if (createdRoomRoute && !!redirectRef.current) {
        redirectToNewPage(createdRoomRoute)
      }

      resetCreateGenAiRoom()
      handleCloseModal()
    }
  }, [createGenAiRoomOutcome])

  const handleWaitTillRedirect = () => {
    redirectRef.current = true
  }


  const handleClickModalCloseButton = () => {
    handleCloseModal()
  }

  const handleIsUploadingState = () => {
    setShowLoader(true)
  }

  const renderContent = () => {
    return (
      <>
        <Flex justify='center' w='95%'>
          <CreateRoomWithAiForm
            uploadFilesState={uploadFilesState}
            handleIsUploadingState={handleIsUploadingState}
            handleClickModalCloseButton={handleClickModalCloseButton}
            handleWaitTillRedirect={handleWaitTillRedirect}
            setNotifyGenAiRoomReady={setNotifyGenAiRoomReady}
            isMobileView={isMobileView}
            showLoader={showLoader}
            uploadFiles={uploadFiles}
            uploadFileMultithreaded={uploadFileMultithreaded}
            uploadFilesReset={uploadFilesReset}
            createGenAiRoom={createGenAiRoom}
          />
        </Flex>
      </>
    )
  }


  return (

    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={MdOutlineGeneratingTokens} color='white' boxSize="1.6em" />
        <Box color='white'>Create a Room with AI</Box>
      </Flex>}
      handleCloseModal={() => handleClickModalCloseButton()}
      showModal={true}
      maxW='35em'
      bgGradient="linear(to-r, #FF2847, #29ABE2)"
    >
      {renderContent()}
    </LaunchdeckModal>
  )
}


const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  uploadFilesState: state.uploadFilesOutcome,
  createGenAiRoomOutcome: state.createGenAiRoomOutcome.results.data,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setNotifyGenAiRoomReady,
      uploadFiles,
      uploadFileMultithreaded,
      uploadFilesReset,
      createGenAiRoom,
      resetCreateGenAiRoom
    },
    dispatch,
  )


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateRoomWithAiModal)))
